// Pick the first value that actually has something to show.
//
// Why this exists: `a ?? b` only falls through on null/undefined, so an EMPTY
// STRING wins — and macOS writes chat.display_name as '' for every 1:1 iMessage
// thread. `thread_label ?? counterparty_name` therefore rendered a BLANK
// conversation name even when the contact name was resolved and present
// (2026-08-04: 140 of Joel's messages displayed nameless for exactly this).
//
// The parser now normalises blank → null at ingest, but rows written before
// that fix still carry '', and any third-party string field can be blank — so
// consumers stay defensive rather than trusting the column.
export function firstNonBlank(...values: Array<string | null | undefined>): string | null {
  for (const value of values) {
    const trimmed = (value ?? '').trim();
    if (trimmed !== '') return trimmed;
  }
  return null;
}
